import { twMerge } from "tailwind-merge";

import EmojiAvatar from "~/components/shared/EmojiAvatar";
import Icon from "~/components/shared/Icon";

export function List({ children }) {
  return <div className="grid gap-3">{children}</div>;
}

export function ListHeader({ name, description }: { name: string; description?: string }) {
  return (
    <div className="grid gap-0.5">
      <h2 className="m-0 text-base font-semibold">{name}</h2>
      {description && <p className="m-0">{description}</p>}
    </div>
  );
}

export function ListContent({ children }) {
  return (
    <div className="divide-gray shadow-depth-200 divide-y overflow-clip rounded-sm">{children}</div>
  );
}

export function ListItem({
  name,
  children,
  icon,
  emoji,
  color,
  onClick,
  className,
}: {
  name: React.ReactNode;
  children?: React.ReactNode;
  icon?: string;
  color?: string;
  emoji?: string;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        "flex w-full cursor-pointer items-center gap-2 px-2 py-3 text-left hover:bg-gray-100",
        className,
      )}
    >
      {(emoji || icon) && (
        <EmojiAvatar
          color={color}
          emoji={emoji}
          fallbackColor="var(--gray-100)"
          fallbackIcon={icon}
          className="shrink-0 self-start ring-2 ring-white"
        />
      )}

      <div className="grid flex-auto gap-0.5">
        <h3 className="m-0 text-sm font-medium">{name}</h3>

        {children && <p className="text-charcoal-300 m-0 text-[13px] leading-snug">{children}</p>}
      </div>

      <Icon
        icon="heroicons/20/solid/chevron-right"
        className="text-charcoal-300 size-5 flex-none"
      />
    </button>
  );
}
